export default "https://client.chat.ao.com/1289/beta/without-externals/assets/images/pattern-bg.png?e283d9327e67f626b50bd90f9f08bb3a";